import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Dotcom2024Service } from '../dotcom2024.service';
import { Meta, Title } from '@angular/platform-browser';
import { MyharrellsService } from '../myharrells.service';

@Component({
  selector: 'app-forms',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './forms.component.html',
  styleUrl: './forms.component.css'
})
export class FormsComponent {

  basePath: string = environment.azureBlobStorageURL;
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Resources/";

  allForms: any[] = [];

  constructor(public myHarrellsService: MyharrellsService, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service) {}

  ngOnInit(): void {  

    //meta tags for SEO
    this.title.setTitle("Harrell`s Forms | The Forms You Need To Get Growing");
    this.meta.updateTag({ name: 'description', content: "Quickly find and complete the necessary documents for your needs. Our Forms Center provides easy access to all essential paperwork." });
    // this.meta.updateTag({ property: 'og:title', content: "og title here -  forms" });
    // this.meta.updateTag({ property: 'og:description', content: "og:description here -  forms" });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here -  forms" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here -  forms" });
    // this.meta.updateTag({ property: 'Twitter:card', content: "twitter:card here -  forms" });
    // this.meta.updateTag({ property: 'Twitter:site', content: "twitter:site here -  forms" });
    // this.meta.updateTag({ property: 'Twitter:title', content: "twitter:title here -  forms" });
    // this.meta.updateTag({ property: 'Twitter:description', content: "twitter:description here -  forms" });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here -  forms" });


    //get all the forms from the database for display in middle of grid.  When the clicks on one of them it will look to blob storage for the file
    this.dotComService.GetAllForms().subscribe((data: any) => {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.FilePath = element.FilePath.replace("#", "%23");
      }

      data = data.filter(x => x.DisplayName != 'Privacy Policy (PDF)'); //per sam not displaying the privacy policy since it is on the footer 
      data = data.filter(x => x.DisplayName != 'General Terms and Conditions (PDF)'); //per sam not displaying  since it is on the footer 
      
      this.allForms = data;
    });
  }





 


}
